/** Price label for a module SKU. Placeholder figures until the Phase 6 pricing study. */
export function price(sku: { price: number; unit: string }) {
  if (sku.unit === 'included') return 'Included';
  return `$${sku.price}` + (sku.unit === 'company' ? '/mo' : sku.unit === 'field-seat' ? '/field seat' : '/office seat');
}
